import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import type { CalendarEventType, NonInteractiveSlotCalendarEvent } from '../../../types';
import { timeToDayjs } from '../../../utils';

interface Props {
  event: NonInteractiveSlotCalendarEvent;
}

export const NonInteractiveSlotEvent = ({ event }: Props) => {
  const { t } = useTranslation('calendar-grid');
  const [dayTime, dayPeriod] = timeToDayjs(event.startTime)?.format('h:mm A').split(' ') ?? [];

  return (
    <div data-event-type={'nonInteractiveSlot' satisfies CalendarEventType} css={containerStyle}>
      <div css={wrapperStyle}>
        <Text as='span' weight='bold' size='small'>
          {dayTime || t('invalid time')}
        </Text>
        {!!dayPeriod && (
          <Text as='span' weight='bold' size='small'>
            {dayPeriod}
          </Text>
        )}
      </div>
    </div>
  );
};

const wrapperStyle = css({
  margin: theme.spacing(0, 0.5),
  padding: theme.spacing(0.5, 0),
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.neutral60}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
});

const containerStyle = css({
  containerType: 'inline-size',
  '@container (width < 80px)': {
    div: { margin: 0 },
  },
  '@container (width < 60px)': {
    'span:last-child': {
      display: 'none',
    },
  },
});
